<script setup>
import { useRoute, useRouter } from 'vue-router'
import { onMounted } from 'vue'
import { periodoSelecionadoVpsIcp } from '../../store/periodoStore'

const route = useRoute()
const router = useRouter()

// Classes para os botões
const activeClass =
  'bg-[#fb5e7f] text-white px-6 py-2 text-sm font-semibold transition'
const inactiveClass =
  'bg-white text-gray-800 px-6 py-2 text-sm font-semibold hover:bg-gray-100 transition'

// Atualiza a URL ao clicar
const selecionarPeriodo = (valor) => {
  periodoSelecionadoVpsIcp.value = valor
  router.replace({ query: { ...route.query, periodo: valor } })
}

// Verifica se já veio pela URL
onMounted(() => {
  const periodoURL = route.query.periodo
  if (['1', '6', '12'].includes(periodoURL)) {
    periodoSelecionadoVpsIcp.value = periodoURL
  }
})
</script>

<template>
  <section class="relative z-0 bg-cover bg-center text-white text-center pt-44 pb-60 px-4">
    <h1 class="text-3xl md:text-5xl font-extrabold mb-4">VPS COM PAINEL ICP</h1>
    <p class="text-lg md:text-xl mb-8">
      Ambiente dedicado em VPS + Painel de Controle Integrator Control Panel + Suporte + Acesso ROOT
    </p>

    <!-- Botões de período -->
    <div class="inline-flex rounded-lg overflow-hidden shadow-lg">
      <button
        @click="selecionarPeriodo('1')"
        :class="periodoSelecionadoVpsIcp === '1' ? activeClass : inactiveClass"
      >
        1 mês
      </button>
      <button
        @click="selecionarPeriodo('6')"
        :class="periodoSelecionadoVpsIcp === '6' ? activeClass : inactiveClass"
      >
        6 meses
      </button>
      <button
        @click="selecionarPeriodo('12')"
        :class="periodoSelecionadoVpsIcp === '12' ? activeClass : inactiveClass"
      >
        12 meses
      </button>
    </div>

      <div class="flex flex-col sm:flex-row justify-center gap-4 mt-14 ">
        <a href="/painel-icp" class="bg-[#f94368] text-white font-semibold py-3 px-6 rounded-full shadow hover:bg-[#e13358] transition">
          VEJA MAIS DETALHES DO PAINEL
        </a>
        <a href="https://demo.icontainer.run:2087/demo" target="_blank" class="bg-blue-600 text-white font-semibold py-3 px-6 rounded-full shadow hover:bg-blue-500 transition">
          ACESSE O DEMONSTRATIVO
        </a>
      </div>
      


  </section>


</template>
